import React from 'react';
import {SingleCard} from '../common/Card';
import servicesData from '../../data/servicesData';

class SingleService extends React.Component{
    
    constructor(props){
        super(props);
        this.state={}
    }

    componentWillMount(){
        const {match}= this.props;
        const service= servicesData.filter(single => single.title=== match.params.title);
        this.setState({service});
    }

    render(){
        return (
            <div className="wrapper">
                <SingleCard {...this.state.service[0]}/>
            </div>    
        );
    }
}

export default SingleService;


// WEBPACK FOOTER //
// ./src/components/services/SingleService.js